<template>
  <div class="personinfo-card">

    <div class="card-title">
      <img class="icon" src="../icons/icon/实习工作经历.png"  alt="">
      <span class="title">工作经历</span>
      <!-- <span class="family-title-fontSize2" @click="add" v-show="addFlag">
        新增附件
      </span>
      <span class="family-title-fontSize2" v-show="addFlag2" @click="submit">
        保存
      </span> -->
      <span style="display: inline-block;vertical-align: bottom;font-size: 12px;color: red;line-height: 1;margin-bottom: 10px;">
        (适用于校园招聘，可填写实习经历；适用于社会招聘及内部招聘，请填写工作经历。)
      </span>
      <div class="opt-right">
        <el-button @click="add" :disabled="isDisabled" type="primary" size="mini" ><i class="el-icon-plus el-icon--left"></i>新增</el-button>
      </div>
    </div>


    <div class="card-body">

      <div class="body-item" v-for="(formData, index) in formDatas" v-bind:key="index" >

          <div class="body-item-tools">
            <i class="el-icon-delete delete" @click="removeData(formData.oid)" v-show="isDisabled==false" ></i>
          </div>

          <el-form
            :inline="true"
            :model="formData"
            ref="formData"
            class="form_data"
            label-width="140px"
            :rules="rules"
            size="medium"
            :disabled="isDisabled"
          >
            <el-form-item
              label="开始时间"
              prop="startdate"
            >
              <el-date-picker
                v-model="formData.startdate"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="结束时间"
              prop="enddate"
            >
              <el-date-picker
                v-model="formData.enddate"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="工作单位"
              prop="workcorp"
            >
              <el-input
                v-model="formData.workcorp"
                :maxlength="120"
              />
            </el-form-item>
            <el-form-item
              label="行业类别"
              popper-class="selectCss"
              prop="industtype"
            >
              <el-select
               v-model="formData.industtype">
                <el-option
                  v-for="item in industtypeList"
                  :key="item.oid"
                  :label="item.name"
                  :value="item.oid"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="规模程度"
              prop="scale"
            >
              <el-select 
              v-model="formData.scale">
                <el-option
                  v-for="item in ndustscaleList"
                  :key="item.oid"
                  :label="item.name"
                  :value="item.oid"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="职务/岗位"
              prop="post"
            >
              <el-input  v-model="formData.post" :maxlength="120" />
            </el-form-item>
            <el-form-item
              prop="content"
            >
              <span slot="label" >
                主要工作内容
                <el-tooltip class="item" effect="dark" content="电厂工作经历请注明单机容量，煤矿工作经历请注明煤矿年产量，化工项目请注明项目规模。" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </span>
              <el-input type="textarea" style="width:770px;" :rows="3" v-model="formData.content" :maxlength="100" 
                placeholder="电厂工作经历请注明单机容量，煤矿工作经历请注明煤矿年产量，化工项目请注明项目规模。" showWordLimit />
            </el-form-item>

            <el-form-item
              label="主要业绩"
              prop="keyper" >
              <el-input type="textarea" style="width:770px;" :rows="3" v-model="formData.keyper" :maxlength="100" showWordLimit />
            </el-form-item>

          </el-form>

      </div>


    </div>




  </div>
</template>

<script>
// import { dictData } from '../request/resumeApi';
import { mapActions } from 'vuex';



export default {
  props: {
    VOStatus: {
      type: String,
      default: () => {
        return 'view'
      }
    },
    workData: {
      type: Array,
      default: () => {
        return []
      }
    },
    formFlag: {
      type: Number,
      default: () => {
        return 1
      }
    }
  },
  data() {
    return {
      // 用户填写信息
      formDatas:[],
      formDataNew:[],
      workForm: {
        oid:0,
        startdate: '',
        enddate: '',
        workcorp: '',
        industtype: '',
        scale: '',
        post: '',
        content: '',
        keyper:''
      },
      currentLiStyle: 0,
      flag: true,
      familyFlag: false,
      addFlag: true,
      addFlag2: false,
      assinList: [], //赋值
      addNewList: [], //新增
      rules: {
        workcorp: [
          {
            required: true,
            message: '请输入工作单位',
            trigger: 'blur'
          },
          // { max: 120, message: '不能超过120个字符', trigger: 'blur' }
        ],
        startdate: [
          {
            type: 'string',
            required: true,
            message: '请选择开始时间',
            trigger: 'change'
          }
        ],
        enddate: [
          {
            type: 'string',
            required: true,
            message: '请选择开始时间',
            trigger: 'change'
          }
        ],
        content: [
          { required: true, message: '请填写工作内容', trigger: 'blur' },
          // { max: 2000, message: '不能超过2000个字符', trigger: 'blur' }
        ],
        industtype: [
          { required: true, message: '请选择行业类别', trigger: 'change' }
        ],
        scale: [
          { required: true, message: '请输入工作规模程度', trigger: 'blur' }
        ],
        post: [
          { required: true, message: '请输入所在岗位/职务', trigger: 'blur' },
          // { max: 120, message: '不能超过120个字符', trigger: 'blur' }
        ],
        // keyper: [
        //   { max: 2000, message: '不能超过2000个字符', trigger: 'blur' } 
        // ]
      },
      industtypeList: [],
      ndustscaleList: []
    }
  },
  methods: {
    ...mapActions([
      'globalDictDataRequest'
    ]),
    //提交表单
    // validForm() {
    //   this.$refs['workForm'].validate((valid) => {
    //     if (valid) {
    //       this.flag = true;
    //       // this.list.push({
    //       //   id: this.id++,
    //       //   startdate: this.workForm.startdate,
    //       //   enddate: this.workForm.enddate,
    //       //   workcorp: this.workForm.workcorp,
    //       //   industtype: this.workForm.industtype,
    //       //   scale: this.workForm.scale,
    //       //   post: this.workForm.post,
    //       //   content: this.workForm.content,
    //       // });
    //       //  this.resetForm(formName)
    //     } else {
    //       return false;
    //     }
    //   });
    // },
    //获取字典
    dictData(type, list, isBlank) {
      
      // let data = {
      //   type: type
      // }
      // dictData(data, isblank).then(response => {
      //   // console.log(response)
      //   this[list] = response.data
      // });

      return this.globalDictDataRequest({key: type, cacheName: list}).then(res => {
        // 深拷贝数据
        let data = [...res].map(item => {
          return {...item};
        });
        if(isBlank) {
          data.unshift({
              name: "请选择...",
              code: "0",
              oid: 0
          });
        }
        this[list] = data;
        return res;
      });




    },
    //新增成员
    add() {

      let newOid = new Date().getTime();
      this.formDataNew.push(newOid);
      
      this.formDatas.push({
        oid: newOid,
        startdate: '',
        enddate: '',
        workcorp: '',
        industtype: '',
        scale: '',
        post: '',
        content: ''
      });

    },
    removeData(oid) {
      this.formDatas = this.formDatas.filter(item => oid != item.oid);
      this.formDataNew = this.formDataNew.filter(item => oid != item);
    },
    clearFormData() {
      // 重置数据
      this.formDatas = [];
      this.formDataNew = [];
      
    },
    resetFormData() {
      // 重置数据
      if(!this.$refs.formData
        || !this.$refs.formData.length 
        || this.$refs.formData.length == 0) {
            return;
      }

      for(let index in this.$refs.formData) {
            this.$refs.formData[index].resetFields();
      }

    },
    formAllValidate(){
      // 表单验证
      return new Promise(function(resolve){
        

        if(!this.$refs.formData 
          || !this.$refs.formData.length 
          || this.$refs.formData.length == 0) {
            resolve({
              "type": "workExp",
              'status': 'ok',
              'msg': '没有数据,验证通过'
            });
        }
        
        var validateAll = [];

        for(let index in this.$refs.formData) {
            validateAll.push(this.$refs.formData[index].validate());
        }

        Promise.all(validateAll).then((values) => {
          // console.log(values)

            // 没有校验时间不能重叠，应增加校验
            let data = this.formDatas;
            let isStartAndEndTime = function(item, all){
              for(let test of all) {
                if(item == test) {
                  continue;
                }
                let start = new Date(test.startdate).getTime();
                let end = new Date(test.enddate).getTime();
                let itemTime = new Date(item.startdate).getTime();
                if(start <= itemTime && end >= itemTime) {
                  return true;
                }

              }
              return false;
            }
            for(let i=0;i<data.length;i++) {
                let start = new Date(data[i].startdate).getTime();
                let end = new Date(data[i].enddate).getTime();
                if(end <= start) {
                  resolve({
                    "type": "workExp",
                    'status': 'fail',
                    'msg': '开始不能大于结束！'
                  });
                }

                if(isStartAndEndTime(data[i], data)) {
                  resolve({
                    "type": "workExp",
                    'status': 'fail',
                    'msg': '所有开始和结束时间不能重叠!'
                  });
                  return;
                }
            }


            resolve({
              "type": "workExp",
              'status': 'ok',
              'msg': '验证通过'
            });

        }).catch((e) => {
            // console.log(e)
            resolve({
              "type": "workExp",
              'status': 'fail',
              'msg': '【工作经历】页签验证不通过'
            });
        });

      }.bind(this));
    },
    formGetValue() {
      // 页面获取值
      return this.formDatas.map(item => {
        if(this.formDataNew.includes(item.oid)) {
          item.oid = 0;
        }
        return item;
      });
    },
    setFormDatas(datas) {
      // 设置数据
      // this.formDatas = datas;
      this.formDataNew = [];

      this.formDatas = datas.map(item => {

          var newItem = {};
          // workForm
          for(let k in this.workForm) {
            if(item[k]) {
              newItem[k] = item[k].key;
            }
          }
          return newItem;
      });


    },
    //保存
    submit() {
      this.addFlag = !this.addFlag
      this.addFlag2 = !this.addFlag2
      this.familyFlag = !this.familyFlag
      this.flag = !this.flag
      this.assinList.push({
        startdate: {value:this.workForm.startdate},
        enddate: {value:this.workForm.enddate},
        industtype: {value:this.workForm.industtype},
        scale: {value:this.workForm.scale},
        workcorp: {value:this.workForm.workcorp},
        content: {value:this.workForm.content},
        post: {value:this.workForm.post}
      })
      this.addNewList.push({
        startdate: this.workForm.startdate,
        enddate: this.workForm.enddate,
        industtype: this.workForm.industtype,
        scale: this.workForm.scale,
        workcorp: this.workForm.workcorp,
        content: this.workForm.content,
        post: this.workForm.post
      })
        // this.$refs['workForm'].resetFields()
    },
    //表单初始化
    initForm() {
      if (this.formFlag == 1) {
        this.familyFlag = false
      } else {
        this.addFlag = !this.addFlag
        this.addFlag2 = !this.addFlag2
        this.familyFlag = !this.familyFlag
        this.flag = !this.flag
      }
    },
    //列表选中框
    familyView(index) {
      // console.log(index)
      this.currentLiStyle = index
    },
    //  表单重置
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  },
  mounted() {

    
    this.dictData('bd_industtype', 'industtypeList', false);
    this.dictData('bd_ndustscale', 'ndustscaleList', false);
    this.initForm()
  },
  computed: {
    isDisabled: function() {
      if(this.$props.VOStatus == 'view') {
        return true;
      } else if(this.$props.VOStatus == 'edit') {
        return false;
      } else if(this.$props.VOStatus == 'new') {
        return false;
      }
      return true;
    }

  }
}
</script>

<style lang="scss" scoped>

.personinfo-card {
  // width: 960px;
  margin-left: 14px;
  margin-right: 2px;
  .card-title {
    position: relative;

    // border-bottom: 1px solid #ebebeb;
    margin-bottom: 20px;

    .icon {
      display:inline-block;
      height:40px;
      vertical-align: middle;
    }

    .title {
      line-height: 40px;
      display: inline-block;
      font-size: 18px;
      font-weight: bold;
      color: #01539f;
      vertical-align: middle;
    }

    &::after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: -12px;
      height: 1px;
      background: #ebebeb;
    }

    .opt-right {
      position: absolute;
      right: 12px;
      top: 0px;
      height: 40px;
      line-height: 40px;

      .el-button {
        border: none;
        border-radius: 0px;
      }

    }

  }



  .card-body {

    .body-item {
      border: 1px solid #eee;
      border-radius: 12px;
      padding: 12px;
      margin-bottom: 20px;
    }

    .body-item-tools {
      height: 30px;
      .delete {
        float: right;
        margin-top: 6px;
        font-size: 18px;
        color: rgba(255,0,0,0.85);
        cursor: pointer;
      }

      .delete:hover {
        color: rgba(255,0,0);
      }

      .delete:active {
        opacity: 0.5;
      }

    }

    .form_data {

    }

  }



}

.form_data {

  .el-input {
    width: 310px;
  }

  .el-select {
    width: 310px;
  }

  .awardcorp-wrap {
    
    .el-textarea__inner {
      resize: none;
    }

  }

}



// ::v-deep .el-textarea__inner {
//   resize: none;
// }

</style>
